module.exports = __webpack_public_path__ + "static/media/icon-3.b91ca675.png";